<template>
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.8028 19.8478V2.15218C17.8028 0.965594 16.8374 0 15.6506 0H6.34847C5.16188 0 4.19629 0.965594 4.19629 2.15218V19.8478C4.19629 21.0346 5.16188 22 6.34847 22H15.6746C16.2497 22 16.809 21.7635 17.2091 21.3513C17.6089 20.939 17.8195 20.3974 17.8028 19.8478ZM16.1791 20.3519C16.0459 20.4897 15.8668 20.5652 15.6745 20.5652H6.34847C5.95294 20.5652 5.63106 20.2434 5.63106 19.8478V2.15218C5.63106 1.75665 5.95294 1.43477 6.34847 1.43477H15.6506C16.0462 1.43477 16.368 1.75665 16.368 2.15218L16.3683 19.8694C16.3738 20.0492 16.3066 20.2206 16.1791 20.3519Z"
        class="icon-fill"
    />
    <path d="M17.1093 2.79785H4.9137V4.23262H17.1093V2.79785Z"
        class="icon-fill"
    />
    <path d="M17.1093 16.6436H4.9137V18.0783H17.1093V16.6436Z"
        class="icon-fill"
    />
    <path d="M11.6093 18.5804H10.4137C10.0174 18.5804 9.69629 18.9015 9.69629 19.2978C9.69629 19.6941 10.0174 20.0152 10.4137 20.0152H11.6093C12.0056 20.0152 12.3268 19.6941 12.3268 19.2978C12.3268 18.9015 12.0056 18.5804 11.6093 18.5804Z"
        class="icon-fill"/>
  </svg>
</template>
<script>
export default {
  name: 'mobile_phone'
}
</script>
<style lang="css">
.icon-fill {
  fill: currentColor;
}

</style>